import { useGetFeatureToggleVariantsForKeys } from '@seek/hirer-feature-toggle';
import { useMemo, useEffect } from 'react';

import {
  experiments,
  hubbleExperiments,
  type TrackingExperiment,
  type TrackingHubbleExperiments,
  type Variant,
} from 'src/app/shared/config/experiments';
import { saveTrackingData } from 'src/app/shared/dataAnalytics/storage';

type FeatureToggleVariants = { value: Variant; matchRule: string };

export const useTrackingExperiments = () => {
  const experimentIds = useMemo(
    () => experiments.map((exp) => exp.experimentId),
    [],
  );
  const featureToggleVariants: Record<string, FeatureToggleVariants> =
    useGetFeatureToggleVariantsForKeys(experimentIds);

  const trackingExperiments: TrackingExperiment[] = useMemo(
    () =>
      experiments.map((experiment) => ({
        num: experiment.experimentNum,
        id: experiment.experimentId,
        variant: featureToggleVariants[experiment.experimentId].value,
      })),
    [featureToggleVariants],
  );

  const trackingHubbleExperiments: TrackingHubbleExperiments = useMemo(
    () =>
      Object.entries(hubbleExperiments).reduce(
        (acc, [key, experiment]) => ({
          ...acc,
          [key]: {
            name: experiment.experimentName,
            participantStatus: experiment.experimentParticipantStatus,
            variant: featureToggleVariants[key].value,
          },
        }),
        {} as TrackingHubbleExperiments,
      ),
    [featureToggleVariants],
  );

  useEffect(() => {
    saveTrackingData({
      experiments: trackingExperiments,
      hubbleExperiments: trackingHubbleExperiments,
    });
  }, [trackingExperiments, trackingHubbleExperiments]);
};
